import React, { useEffect } from "react";
import { Rept } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Card, CardContent, colors, Container, Divider, Paper, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import BalanceCard from "../../../../components/BalanceCard";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
    root: {
        // height: '80px',
        fontFamily: "Amiri-Regular",
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    rootBodys: {
        fontFamily: "Amiri-Regular",
        backgroundColor: colors.grey[300],
        borderBottomColor: colors.grey[700],
        borderBottomWidth: "5px",
        borderBottomStyle: "solid",
        color: "#000",
        direction: "rtl",
    },
    content: {
        // alignItems: "center",
        //display: "flex",
        fontFamily: "Amiri-Regular",
    },
    title: {
        fontWeight: 500,
        fontFamily: "Amiri-Regular",
    },
}));

function RestrictionsFooter(props) {
    const {
        paramsList,
        params,
        total_dept,
        total_credit
    } = props;
    const cls = useRptAF();
    const { t } = useTranslation(["forms"]);

    const style={ fontFamily: "Amiri-Regular",fontSize:"1rem",fontWeight:"bold" };
    const classes = useStyles();
    return (
        <Card className={clsx(classes.root)}
        >
            <CardContent>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        backgroundColor: colors.grey[300],
                        borderBottomColor: colors.grey[700],
                        borderBottomWidth: "5px",
                        borderBottomStyle: "solid",
                        color: "#000",
                        direction: "rtl",
                        paddingTop: "10px",
                        paddingBottom:"10px"
                    }}
                >
                    <Grid container item lg={12} md={12} sm={12} xs={12} spacing={1}>
                        <Grid container item lg={3} md={3} sm={3} xs={3} >
                            <Grid item lg={3} md={4} sm={5} xs={12} style={style} >
                                <div> {"الفارق  : "} </div>
                            </Grid>
                            <Grid item lg={9} md={8} sm={7} xs={12} >
                                <div style={parseFloat(total_dept ?? 0).toFixed(2) != parseFloat(total_credit ?? 0).toFixed(2) ? 
                                    { backgroundColor: colors.red[500],fontSize:"1rem",fontWeight:"bold"  } : 
                                    { backgroundColor: "#fff" ,fontSize:"1rem",fontWeight:"bold" }}>
                                    {parseFloat(total_dept ?? 0).toFixed(2) > parseFloat(total_credit ?? 0).toFixed(2) ? (parseFloat(total_dept ?? 0).toFixed(2) - parseFloat(total_credit ?? 0)).toFixed(2) : (total_credit - parseFloat(total_dept ?? 0)).toFixed(2)}
                                    {parseFloat(total_dept ?? 0).toFixed(2) > parseFloat(total_credit ?? 0).toFixed(2) ? "مدين" : parseFloat(total_dept ?? 0).toFixed(2) < parseFloat(total_credit ?? 0).toFixed(2) ? "دائن" : ""}
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container item lg={3} md={3} sm={3} xs={3}style={style} >
                            <Grid item lg={4} md={5} sm={5} xs={12} >
                                <div> {"اجمالي المدين"+ " : "}</div>
                            </Grid>
                            <Grid item lg={8} md={7} sm={7} xs={12} >
                                <div> {parseFloat(total_dept ?? 0).toFixed(2)}</div>

                            </Grid>
                        </Grid>
                        <Grid container item lg={3} md={3} sm={3} xs={3} style={style} >
                            <Grid item lg={5} md={5} sm={5} xs={12} >
                                <div> {" اجمالي الدائن" + "  : "}</div>
                            </Grid>
                            <Grid item lg={7} md={7} sm={7} xs={12} >
                                <div>{parseFloat(total_credit ?? 0).toFixed(2)}</div>

                            </Grid>
                        </Grid>
                       
                        <Grid item lg={3} md={3} sm={3} xs={3} style={style} >
                            <div>{parseFloat(total_dept ?? 0).toFixed(2) != parseFloat(total_credit ?? 0).toFixed(2)? "قيد غير متوازن" : "قيد  متوازن"}</div>
                        </Grid>
                    </Grid>
                </Container>
            </CardContent>
        </Card>

    );
}

export default RestrictionsFooter;
